export default "__VITE_ASSET__0feff638__"